import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Card, SectionTitle } from '../ui';
import { api, eur, errMsg, fmtDateTime } from '../api';

const LABELS = [['LOGIN', 'Accesso alla piattaforma'], ['/topup-requests', 'Richiesta di ricarica'], ['/cs/', 'Ricerca o acquisto informazioni aziendali'], ['/aml/', 'Reputational check'],
  ['/monitoring', 'Monitoraggio'], ['/property', 'Richiesta visura catastale'], ['/travel', 'Travel Security'], ['/whistleblowing', 'Whistleblowing'], ['/team', 'Gestione utenti'],
  ['/wallet', 'Plafond'], ['/auth', 'Impostazioni account']];
const describe = (a) => (a.action === 'LOGIN' ? 'Accesso alla piattaforma' : (LABELS.find(([k]) => a.path.includes(k)) || [null, a.path])[1]);

export function TopupRequests() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get('/topup-requests').then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const decide = async (r, action) => {
    try {
      const { data } = await api.post(`/topup-requests/${r.id}/${action}`);
      if (action === 'reject') { toast.success('Richiesta rifiutata'); load(); return; }
      const pay = await api.post('/wallet/topup', { amount_eur: data.amount_eur, origin_url: window.location.origin, method: 'stripe' });
      window.location.href = pay.data.checkout_url;
    } catch (e) { toast.error(errMsg(e)); load(); }
  };
  const pending = items.filter((r) => r.status === 'pending');
  if (!items.length) return null;
  return (
    <Card className="p-6 mb-6" data-testid="topup-requests">
      <SectionTitle>Richieste di ricarica {pending.length > 0 && <span className="ml-2 text-[10px] px-1.5 py-0.5 rounded-sm bg-[#C2423A] text-white">{pending.length}</span>}</SectionTitle>
      {items.map((r) => (
        <div key={r.id} className="py-3 border-t border-[#1F242C] flex flex-wrap items-center gap-3" data-testid={`topup-request-${r.id}`}>
          <div className="flex-1 min-w-[200px]"><p className="text-sm text-[#F2F2F2]">{r.member_name || r.member_email} · <span className="font-mono">{eur(r.amount_cents)}</span></p><p className="text-[11px] text-[#5A5F67]">{fmtDateTime(r.created_at)}{r.note ? ` · ${r.note}` : ''}</p></div>
          {r.status === 'pending' ? (
            <>
              <button onClick={() => decide(r, 'approve')} className="h-8 px-3 text-xs bg-[#D4AF37] text-[#050505] font-semibold rounded-sm" data-testid={`topup-approve-${r.id}`}>Approva e paga</button>
              <button onClick={() => decide(r, 'reject')} className="h-8 px-3 text-xs border border-[#1F242C] rounded-sm" data-testid={`topup-reject-${r.id}`}>Rifiuta</button>
            </>
          ) : <span className="text-[10px] font-mono uppercase text-[#8A8F97]">{r.status === 'approved' ? 'Approvata' : 'Rifiutata'}</span>}
        </div>
      ))}
    </Card>
  );
}

export function ActivityLog({ members }) {
  const [who, setWho] = useState('');
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/team/activity', { params: who ? { member_id: who } : {} }).then((r) => setItems(r.data)).catch(() => {}); }, [who]);
  return (
    <Card className="p-6" data-testid="team-activity">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <SectionTitle>Registro attività</SectionTitle>
        <select value={who} onChange={(e) => setWho(e.target.value)} className="h-9 px-2 bg-transparent border border-[#1F242C] rounded-sm text-sm text-[#C9CCD1]" data-testid="team-activity-filter">
          <option value="">Tutti gli utenti</option>
          {members.map((m) => <option key={m.id} value={m.id}>{m.name || m.email}</option>)}
        </select>
      </div>
      {!items.length && <p className="text-sm text-[#5A5F67]">Nessuna attività registrata.</p>}
      <div className="max-h-[420px] overflow-y-auto">
        {items.map((a, i) => (
          <p key={`${a.at}-${i}`} className="grid grid-cols-[130px_minmax(0,1fr)_minmax(0,1.3fr)] gap-3 py-2 border-t border-[#1F242C] text-xs text-[#C9CCD1]" data-testid="team-activity-row">
            <span className="font-mono text-[#8A8F97]">{fmtDateTime(a.at)}</span><span className="truncate">{a.actor_name || a.actor_email}</span><span className="truncate">{describe(a)}</span>
          </p>
        ))}
      </div>
    </Card>
  );
}
